import * as React from 'react'
import { FieldErrors } from 'react-hook-form/dist/types/errors'
import { cls } from '../../utils/utils'
import { SITE_URL } from '../../utils/constants'
import { FormFields } from '../Dialog/Dialog.types'
import styles from './CheckBox.module.scss'

export interface ICheckBox {
  errors: FieldErrors<FormFields>
  register: any
  className?: string
}

const CheckBox: React.FC<ICheckBox> = ({ errors, register, className = '' }) => {
  return (
    <div className={styles.container}>
      <input
        name="checkbox"
        type="checkbox"
        required
        className={cls(styles.checkbox, className)}
        {...register('checkbox', { required: 'Please, confirm that you agree.' })}
        id="agree"
      />
      <label htmlFor="agree">
        <p className={cls('text--label', styles.text)}>
          I have read and accept the{' '}
          <a href={`${SITE_URL}privacy-policy`} target="_blank" className={styles.link}>
            Privacy Policy
          </a>
          .
        </p>
      </label>
      {errors.checkbox && <p className={cls('text--button', styles.message)}>{errors.checkbox.message}</p>}
    </div>
  )
}

export default CheckBox
